// extracted by mini-css-extract-plugin
export default {"base":"vp_cvovA","message":"vp_VGCLt","label":"vp_y2SmX","description":"vp_MdGpC"};